<template>
    <div id="page-container-white">
        <Appbar/>
         <div class="jumbotron jumbotron-fluid">
        <div class="container">
            <div class="row text-center jumbotext">
            <div class="col-12">
                    <h1 class="text-white ">WORLD's LARGEST FREE TRADE AREA </h1>
            </div>
            </div>
        </div>
        </div>
        <Spinner :color="'text-danger'" v-if="isLoading"/>
        <div class="container" v-if="!isLoading">
            <div class="row justify-content-center" v-if="article">
            <div class="col-sm-8 ">

                <div class="container">
                    <div class="blog-post">
                    <h2 class="blog-post-title">
                        {{article.topic}}
                    </h2>
                    <p v-if="author" class="blog-post-meta pb-4">{{author.date && author.date}} by {{author.author}}</p>
                    <p v-if="!author" class="blog-post-meta pb-4">{{article.created_at && article.created_at[0] | moment}} by {{article.created_by && article.created_by.first_name}} {{article.created_by && article.created_by.last_name}}</p>
                    <img v-if="author" class="img-thumbnail" :src="author.image" alt="">
                    <img v-if="article.pic" class="img-thumbnail" :src="article.pic" alt="">
                    <p class="pt-4 text-justify">{{article.body}} </p>
                    <div class="row" v-if="author">
                        <div class="col-12">
                           <hr>
                           <p>
                                <strong class="text-danger" style="font-size:1.6em">Note</strong>
                            This article first appears on <a target="_blank" :href="author.source">{{author.sourcename}}</a>, 
                            and is reproduced here on a fair use basis. 
                           </p>
                        </div>
                    </div>
                    <hr>
                    <p>Comments {{`[${article.comments.length}]`}}</p>
                    <div class="row">
                        <div class="geser" v-if="article.comments">
                        <div class="media" v-for="(comment,key) in article.comments" :key="key">
                            <div class="media-left mr-2">
                            <img src="http://fakeimg.pl/50x50" class="media-object" style="width:40px">
                            </div>
                            <div class="media-body">
                            <h4 class="media-heading title">{{comment.created_by.first_name}}</h4>
                            <p class="komen">
                                {{comment.comment}}<br>
                                <!-- <a href="#">reply</a> -->
                            </p>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                        <label for="comment"><b>Write your comment</b></label>
                        <textarea name="comment" class="form-control" rows="7" v-model="comment"></textarea>
                    </div>
                    <div class="col-12"><button :disabled='!comment' @click="addComment" class="btn btn-danger btn-sm float-right my-3">Send comment</button></div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <div class="col-sm-3 col-sm-offset-1 blog-sidebar">
                <!-- <div class="sidebar-module sidebar-module-inset">
                    <h4 class="text-center">About</h4>
                    <p>Etiam porta <em>sem malesuada magna</em> mollis euismod. Cras mattis consectetur purus sit amet fermentum. Aenean lacinia bibendum nulla sed consectetur.</p>
                </div> -->
            <div class="sidebar-module text-center">
            <h4>Archives</h4>
            <!-- <ol class="list-unstyled">
              <li><a href="#">March 2014</a></li>
              <li><a href="#">February 2014</a></li>
              <li><a href="#">January 2014</a></li>
              <li><a href="#">December 2013</a></li>
              <li><a href="#">November 2013</a></li>
              <li><a href="#">October 2013</a></li>
              <li><a href="#">September 2013</a></li>
            </ol> -->
          </div>
            </div>
        </div>
        </div>
    <FinalFooter />
    </div>
</template>

<script>
import moment from 'moment'
import Appbar from './appBar'
import authors from './../helpers/authors'
import url from '../helpers/url.js'
import service from '../helpers/service'
import Spinner from '../components/Spinner'
import FinalFooter from '../components/FinalFooter'

    export default {
        components:{
            Appbar,
            FinalFooter,
            Spinner
        },
        data() {
            return {
                article:{},
                author:{},
                comment:null,
                isLoading:false
            }
        },
        filters: {
            moment: function (date) {
                return moment(date).format('MMMM Do YYYY');
            }
            },
        methods: {
             addComment() {
                 const user = this.$session.get('entity')
                    if(!user) {
                        window.location.replace(`/redirect?service=login`)
                    }
                 const data = {
                    "comment": this.comment,
                    "article_id": this.$route.params.articleID
                }
                 this.$store.dispatch('addComment',data) 
                    .then(response => {
                        if(response) {
                            this.toast({
                                message:'comment added successfully',
                                type:'success'
                            })
                            
                            window.location.reload()
                        }
                    }).catch(err => {
                        if(err?.response?.data == undefined) {
                        this.toast({
                            message:'Network error. Check network connection and try again.',
                            type:'error'
                        })
                        }
                    })
                
             },
             fetchApprovedArticle() {
                 this.isLoading = true
                this.$store.dispatch('fetchApprovedArticle')
                    .then( response => {
                        
                        const data = response.data.find(article => article.id == this.$route.params.articleID)
                        this.article = data
                        console.log(data)
                        if(!data) return this.$router.push({ name:"pageNotfound"})
                        const author = authors.find(author => author.id == this.$route.params.articleID)
                        this.author = author
                        // 
                        this.isLoading = false;
                    })
                    .catch(err => {
                       this.isLoading = false
                        if(err?.response?.data == undefined) {
                        this.toast({
                            message:'Network error. Check network connection and try again.',
                            type:'error'
                        })
                    }
                    })
            }
        },
        created() {
            this.fetchApprovedArticle()
            
        }
    }
</script>

<style  scoped>
 .jumbotron{
    background:url('../assets/AFCFTA  HEADER ARTICLES.jpg');
    background-size:cover;
    height:300px;
    margin-top:-75px
    }
    .jumbotext{
        margin-top:120px
    }
    .blog-post {
    margin-bottom: 60px;
    }
    .blog-post-title {
    margin-bottom: 5px;
    font-size: 40px;
    }
    .blog-post-meta {
    margin-bottom: 20px;
    color: #999;
    }
    .sidebar-module-inset {
    padding: 15px;
    background-color: #f5f5f5;
    border-radius:4px
    }
    .sidebar-module {
    padding: 15px;
    margin: 0 -15px 15px;
}
.title {
    font-size: 14px;
    font-weight:bold;
}
.komen {
    font-size:14px;
}
.geser {
    margin-left:55px;
    margin-top:5px;
}
    @media screen and (max-width: 600px) {
       h1 {
           font-size: 1.8em;
           margin-top:50px;
       }}   
</style>